import { render, staticRenderFns } from "./CategoriasDetalleCompras.vue?vue&type=template&id=5fca1f46&scoped=true"
import script from "./CategoriasDetalleCompras.vue?vue&type=script&lang=js"
export * from "./CategoriasDetalleCompras.vue?vue&type=script&lang=js"
import style0 from "./CategoriasDetalleCompras.vue?vue&type=style&index=0&id=5fca1f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca1f46",
  null
  
)

export default component.exports